import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 16, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionEyebrow = ({ children, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-2 font-display text-xs uppercase tracking-[0.25em] text-brand-600"
  >
    <span className="h-px w-8 bg-brand-600/70" />
    {children}
  </span>
);

// Lightweight, very subtle ambient highlight (replaces dark orbs)
export const SoftHalo = () => (
  <div
    aria-hidden
    className="pointer-events-none absolute inset-0 -z-10"
    style={{
      background:
        "radial-gradient(ellipse 60% 40% at 80% 20%, rgba(37,99,235,0.06), transparent 60%), radial-gradient(ellipse 50% 40% at 10% 90%, rgba(96,165,250,0.05), transparent 60%)",
    }}
  />
);
